import { RESTClient } from '@api/client';
import { API_URL } from './apiDictionary';
import { prepareUrl } from 'src/utils/routerHelpers';
import { QueriesFilters } from '@restore/queries/queries.types';

export const getPMQueries = (
  clinicalTrialId: string,
  filters?: QueriesFilters
) => {
  return RESTClient.get(API_URL.pmQueries, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    params: {
      page: filters?.page ? filters.page - 1 : 0,
      size: filters?.size ?? 10,
      ...(filters?.sort && { sort: filters.sort }),
      status: filters?.status,
      search: filters?.search,
      visitId: filters?.visitId,
    },
  });
};

export const getPMQueryById = (queryId: string, clinicalTrialId: string) => {
  return RESTClient.get(prepareUrl(API_URL.pmQueriesById, [queryId]), {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};
